import { useQuery } from "@tanstack/react-query";
import type { Category, SiteSettings } from "@triple-h/shared";
import { publicApi } from "../api";
import { fallbackSite } from "../lib/site";

export function useSite() {
  return useQuery({
    queryKey: ["public-site"],
    queryFn: () => publicApi<SiteSettings>("/site"),
    placeholderData: fallbackSite,
    staleTime: 5 * 60_000
  });
}

export function useCategories() {
  return useQuery({
    queryKey: ["public-categories"],
    queryFn: () => publicApi<Category[]>("/categories"),
    staleTime: 5 * 60_000
  });
}
